import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import { Input, InputProps } from '@bootstrap-styled/v4'
import { remCalc } from '../../../styles/functions'

type RangeProps = Omit<InputProps, 'ref'> & {
    range?: number
    color?: 'primary' | 'blue'
}

const InputRangeUnstyled: React.FC<RangeProps> = ({ color = 'primary', className, ...props }) => {
    const classes = classNames(className, { [`range-color-${color}`]: color })
    return <Input type="range" className={classes} {...props} />
}

const InputRange = styled(InputRangeUnstyled)`
    && {
        outline: none;
        appearance: none;
        width: ${remCalc('180px')};
        height: ${remCalc('2px')};
        border-radius: 5%;
        border-width: ${props => props.range || '0px'};
        /* background-image: ${props =>
            `linear-gradient(to right, ${props.theme['$blue-links']} 0%, ${props.theme['$blue-links']} ${props.range}%, ${props.theme['$strong-gray']} ${props.range}%, ${props.theme['$strong-gray']} 100%);`}; */

        ::-webkit-slider-thumb {
            appearance: none;
            width: ${props => props.theme['$text-large']};
            height: ${props => props.theme['$text-large']};

            border-radius: 50%;
            /* cursor: ew-resize; */
        }
        &:focus {
            outline: none;
        }
        &.range-color-primary {
            background-image: ${props =>
                `linear-gradient(to right, ${props.theme['$primary']} 0%, ${props.theme['$primary']} ${props.range}%, ${props.theme['$strong-gray']} ${props.range}%, ${props.theme['$strong-gray']} 100%);`};
            ::-webkit-slider-thumb {
                background-image: radial-gradient(
                circle,
                ${props => props.theme['$primary']} 0%,
                ${props => props.theme['$primary']} 5%
            );
            }
        }
        &.range-color-blue {
            background-image: ${props =>
                `linear-gradient(to right, ${props.theme['$blue-links']} 0%, ${props.theme['$blue-links']} ${props.range}%, ${props.theme['$strong-gray']} ${props.range}%, ${props.theme['$strong-gray']} 100%);`};
            ::-webkit-slider-thumb {
                background-image: radial-gradient(
                circle,
                ${props => props.theme['$blue-links']} 0%,
                ${props => props.theme['$blue-links']} 5%
            );
            }
        }
    }
`

export default InputRange
